import Api from '../interface/index';

export function resolveSiteImage(image, domain) {
  if (typeof image !== 'string' || !image.trim()) {
    return '';
  }

  const source = image.trim();
  if (/^https?:\/\//i.test(source) || /^\/\//.test(source)) {
    return source;
  }

  const configuredDomain = typeof domain === 'string' && /^https?:\/\//i.test(domain.trim())
    ? domain.trim()
    : '';
  const baseUrl = configuredDomain || Api.commonUrl || '';
  if (!baseUrl) {
    return '';
  }

  const path = source.replace(/\\/g, '/').replace(/^(\.\/|\/)+/, '');
  return `${baseUrl.replace(/\/+$/, '')}/${path}`;
}
